import { isNil } from 'lodash'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { ResourcesDetailsHeader } from './ResourcesDetailsHeader'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { ResourcesDetailsSection } from './ResourcesDetailsSection'
import { ResourceImageSection } from './ResourceImageSection'
import { ResourceFileSection } from './ResourceFileSection'
import { useGetResourceById } from 'hooks/api/Resources/useGetResourceById'

export const ResourcesDetailsPage = () => {
  const { id: idParam } = useParams()
  const ResourceId = Number(idParam)
  const ResourceQuery = useGetResourceById(ResourceId)

  if (ResourceQuery.isPending) {
    return <ActivityIndicator />
  }

  if (ResourceQuery.isError || isNil(ResourceQuery.data)) {
    return <Box>An error occurred fetching the Resource.</Box>
  }

  const resource = ResourceQuery.data

  return (
    <ResourcesDetailsHeader resource={resource}>
      <Box>
        <ResourcesDetailsSection />
        <ResourceImageSection resource={resource} />
        {!resource.url ? <ResourceFileSection resource={resource} /> : null}
      </Box>
    </ResourcesDetailsHeader>
  )
}
